import { BadgesExplained } from "../components/NameBasisBadge";
/** Trust and privacy. Every statement here is true of the code today; what is
 *  not built yet is marked planned. Pending legal review. */
export function PrivacyPage() {
  return (
    <article className="prose">
      <p className="draft" data-testid="draft-marker" role="note">Draft — pending legal review</p>
      <h1>Trust and privacy</h1>
      <p className="lead">The network describes people without exposing them. Here is exactly what that means today.</p>

      <h2>What is public</h2>
      <ul>
        <li>Claims: the claim type, your description, any fields you fill, tags, the issuer it names, and the SHA-256 hash of an attached file.</li>
        <li>Vouches: who vouched (their DID), their basis and the relationship they gave.</li>
        <li>Anchors, delegations used for anchors, and DID documents with their full history.</li>
        <li>The rail log: every entry, hash-chained, readable by anyone without an account.</li>
      </ul>
      <p>Whatever you type into a description, a field or a relationship is public. Do not put contact details there.</p>

      <h2>Issuer names and their badges</h2>
      <BadgesExplained />
      <h2>What never enters the graph</h2>
      <ul>
        <li>Names, email addresses, phone numbers and IP addresses: the rail has no place for them, and its tables are checked for them.</li>
        <li>Files: an attached file is hashed in your browser and never uploaded. Only its hash is published.</li>
      </ul>

      <h2>Your keys</h2>
      <p>Your keys are made and kept on your device. In the web app, your recovery phrase derives your root key; the browser holds a separate signing key it cannot export where the browser supports that. On browsers without the needed key type, the root key is kept in this browser's storage. Keys are yours: lose your phrase and the chain is gone. QSeverse never holds them.</p>

      <h2>Vouches you change your mind about</h2>
      <ul>
        <li>Declines are never shown publicly.</li>
        <li>Withdrawals (planned): a withdrawn vouch will stay visible, muted and struck through, so the history does not silently change.</li>
        <li>Erasure: the rail can erase the content of an entry at the request of the key that signed it. The log keeps the entry's hash, so the chain stays checkable, but the content is gone. The web app does not offer this yet (planned).</li>
      </ul>

      <h2>The correlation risk, plainly</h2>
      <p>Everything signed by one DID is linked to that DID, publicly and permanently. If you use the same DID for your job, your club and your volunteering, anyone can see they are the same person. Use separate DIDs for contexts you want kept apart. Today the web app holds one identity per browser profile, so use a separate profile for each context; several identities in one wallet is planned.</p>

      <h2>Roles under India's DPDP Act</h2>
      <p>For credentials an organisation issues through its QSeverse console, the organisation decides what to issue and QSeverse processes it on the organisation's behalf: the intended position is that the organisation is the data fiduciary and QSeverse a data processor. For claims and vouches you publish on the rail yourself, you decide what is published. These positions are pending legal review.</p>

      <h2>Planned</h2>
      <p>Stewardship of the network beyond QSeverse, per-DID rate limits, and the items marked planned above.</p>
    </article>
  );
}
